import { Component, ErrorInfo } from "react";
import { Alert, AlertDescription } from "@zapier/design-system";

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
  renderNullOnError?: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // TODO: log error to Datadog
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.props.renderNullOnError) {
        return null;
      }

      return (
        <Alert status="error" title={"Something went wrong!"}>
          <AlertDescription>{this.state.error.message}</AlertDescription>
        </Alert>
      );
    }

    return this.props.children;
  }
}
